module.exports = __webpack_public_path__ + "ab370de3eeebad7af4b76e44d225dabb.jpg";